export const tagBlocks = {
  desktop: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            className: 'mx-auto u-center w-full max-w-[1100px]',
            lazy: false,
          },
        },
      ],
    },
    afterPagination: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'category',
            mode: 'stnWidget',
          },
        },
      ],
    },
    labelsDetailTop: {
      showAt: [2],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsTop',
          },
          showAt: 2,
        },
      ],
    },
    labelsTop: {
      showAt: [4],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsTop',
          },
          showAt: 4,
        },
      ],
    },
    labelsMiddle1Desktop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle1',
          },
        },
      ],
    },
    labelsMiddle2: {
      showAt: [9],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle2',
          },
          showAt: 9,
        },
      ],
    },
    labelsMiddle2Detail: {
      showAt: [9],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle2',
          },
          showAt: 9,
        },
      ],
    },
    labelsMiddle2End: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle2',
          },
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
  },
  mobile: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            className: 'mx-auto u-center w-full',
            lazy: false,
          },
        },
      ],
    },
    afterPagination: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'category',
            mode: 'feed',
          },
        },
      ],
    },
    labelsTop: {
      showAt: [1, 4, 7],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsTop',
          },
          showAt: 1,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle1',
          },
          showAt: 4,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle1',
          },
          showAt: 7,
        },
      ],
    },
    labelsDetailTop: {
      showAt: [1],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsTop',
          },
          showAt: 1,
        },
      ],
    },
    labelsMiddle1: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle1',
          },
        },
      ],
    },
    labelsMiddle2: {
      showAt: [(index) => index >= 2 && index % 3 === 2],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle2',
          },
          showAt: (index) => index >= 2 && index % 3 === 2,
        },
      ],
    },
    labelsMiddle2Detail: {
      showAt: [(index) => index >= 1 && index % 3 === 1],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'labelsMiddle2',
          },
          showAt: (index) => index >= 1 && index % 3 === 1,
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
  },
};
